import { getCookie, setCookie } from '@/utils';

const UpDownColorKey = 'Trade_Up_Down_Color';

// 设置涨跌颜色
export const setUpDownMode = (mode) => {
  setCookie(UpDownColorKey, mode);
};

// 获取涨跌颜色 - 默认绿涨红跌
export const getUpDownMode = () => getCookie(UpDownColorKey) || 'green_up_red_down';

// 修正涨跌颜色
export const fixUpDownColor = (color) => {
  if (!color) { return ''; }

  const mode = getUpDownMode();

  if (mode === 'green_up_red_down') {
    return color;
  }

  // 红涨绿跌的时候交换颜色
  const map = {
    'u-1-cl': 'u-4-cl', 'u-4-cl': 'u-1-cl', 'u-1-bg': 'u-4-bg', 'u-4-bg': 'u-1-bg',
  };

  return map[color] || color;
};
